/**
 * GuidelineTocPanel — sticky "On this page" navigation built from the doc's
 * headings (see extractHeadings). The active item is driven by the parent's
 * scrollspy; clicking an item scrolls its section into view.
 */
import Box from "@mui/material/Box";

import Flx from "../../../components/layout/Flx";
import Txt from "../../../components/typography/Txt";
import { teal } from "../../../theme/colors";

export default function GuidelineTocPanel({ headings, activeId, onSelect }) {
  if (!headings || headings.length === 0) return null;

  return (
    <Box
      component="nav"
      aria-label="Table of contents"
      sx={{ position: "sticky", top: 0, alignSelf: "flex-start", py: 2.5, pr: 1 }}
    >
      <Txt
        sx={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#94a3b8",
          mb: 1,
          display: "block",
        }}
      >
        On this page
      </Txt>
      <Flx column sx={{ borderLeft: "1px solid #e5e7eb" }}>
        {headings.map((h) => {
          const active = h.id === activeId;
          return (
            <Box
              key={h.id}
              component="button"
              type="button"
              onClick={() => onSelect(h.id)}
              title={h.text}
              sx={{
                appearance: "none",
                background: "none",
                border: "none",
                textAlign: "left",
                cursor: "pointer",
                display: "block",
                width: "100%",
                pl: h.level === 1 ? 1.5 : h.level === 2 ? 2 : 3.25,
                pr: 1,
                py: 0.5,
                ml: "-1px",
                borderLeft: "2px solid",
                borderColor: active ? teal[700] : "transparent",
                fontFamily: "Inter, sans-serif",
                fontSize: h.level === 1 ? 12.5 : 12,
                fontWeight: active ? 700 : h.level === 1 ? 600 : 400,
                lineHeight: 1.35,
                color: active ? teal[700] : "#64748b",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                transition: "color 0.12s, border-color 0.12s",
                "&:hover": { color: teal[700] },
              }}
            >
              {h.text}
            </Box>
          );
        })}
      </Flx>
    </Box>
  );
}
